/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Return Model of Access Restriction
 */
export interface AccessRestrictionModel {
  id?: string;
  accessTypes?: Array<AccessRestrictionModelAccessTypesEnum> | null;
  operationTypes?: Array<AccessRestrictionModelOperationTypesEnum> | null;
  isAdminRestriction?: boolean;
}
export enum AccessRestrictionModelAccessTypesEnum {
  System = 'System',
  Admin = 'Admin',
  User = 'User'
}
export enum AccessRestrictionModelOperationTypesEnum {
  Read = 'Read',
  Write = 'Write'
}
